import React, { FunctionComponent } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Switch as MuiSwitch,
} from '@mui/material';
import cx from 'classnames';
import useStyles from './Switch.styles';

interface IProps {
  id: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  labelPlacement?: 'bottom' | 'top' | 'end' | 'start' | undefined;
  customLabelClasses?: string;
}

const Switch: FunctionComponent<IProps> = ({
  id,
  checked,
  onChange,
  label,
  labelPlacement,
  customLabelClasses
}) => {
  const classes = useStyles();
  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <MuiSwitch
            id={id}
            name={id}
            data-testid={`${id}__switch`}
            checked={checked}
            onChange={onChange}
            color="primary"
          />
        }
        label={label}
        labelPlacement={labelPlacement}
        classes={{
          root: classes.labelRoot,
          label: cx(customLabelClasses, {
            [classes.label]: label,
            [classes.uncheckedLabel]: label && !checked,
          }),
        }}
      />
    </FormGroup>
  );
};

export default Switch;
